var VOILUTFunctionType;
(function (VOILUTFunctionType) {
    VOILUTFunctionType["LINEAR"] = "LINEAR";
    VOILUTFunctionType["SAMPLED_SIGMOID"] = "SIGMOID";
    VOILUTFunctionType["LINEAR_EXACT"] = "LINEAR_EXACT";
})(VOILUTFunctionType || (VOILUTFunctionType = {}));
export default VOILUTFunctionType;
